module.exports = __webpack_public_path__ + "static/media/qc.7b835d83.svg";